import React from "react";
import postIcon from "../../../imgs/post.svg";
import { ArrowTopIcon } from "../SvgIcons/SvgIcons";
import departmentIcon from "../../../imgs/departmenticon.svg";
import { useHistory } from "react-router-dom";

const BountyCard = ({ myBounty }) => {
  const {
    fullName,
    company,
    title,
    bountyType,
    demandPrice,
    department,
    reason,
    offers,
    status,
  } = myBounty;

  const history = useHistory();

  const handleSubmit = () => {
    history.push({
      pathname: "/bountiesoffer",
      state: { myBounty },
    });
  };

  const handleBountyComplete = () => {
    history.push({
      pathname: '/bountiesoffercomplete',
      state: {myBounty},
    });
  };

  return (
    <div className="bounty-card-wrapper">
      <div className="feed-card-wrapper">
        <div>
          <div className="row m-0 justify-content-between">
            <h2 className="heading">
              <img
                src={bountyType === "person" ? postIcon : departmentIcon}
                alt="logo"
              />
              {bountyType === "person" ? fullName : company}
            </h2>
            <h2 className="small-heading">${demandPrice}</h2>
          </div>
          <p className="color-black">
            {bountyType === "person" ? `${title} at ${company} ` : department}
          </p>
        </div>
        <span>For {reason}</span>
      </div>
      {status === 'completed' ? (
        <button className="btn-style" onClick={handleBountyComplete}>
          Bounty Completed <ArrowTopIcon />
        </button>
      ) : (
        <button className="btn-style" onClick={handleSubmit}>
          {offers.length} Offer <ArrowTopIcon />
        </button>
      )}
    </div>
  );
};

export default BountyCard;
